import { render, staticRenderFns } from "./AssignedProductsList.vue?vue&type=template&id=e701c62c&scoped=true"
import script from "./AssignedProductsList.vue?vue&type=script&lang=js"
export * from "./AssignedProductsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e701c62c",
  null
  
)

export default component.exports